import { useEditor, useNode } from "@craftjs/core";
import React from "react";
import { GoogleMapSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import icon from "./icon";
import { CMSGoogleMapSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";
import { EmbedOverlay } from "../../block-helpers";

export const GoogleMap = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();

  const {
    location = "New York",
    latitude = "40.7128",
    longitude = "-74.0060",
    zoom = "14",
    mapType = "roadmap",
    mapMode = "place",
    apiKey,
    language = "en",
  } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-google-map": true,
      [`google-map-${id}`]: id,
      "g-embed": true,
    },
    blockProps.className,
  );

  const GRIGORA_MAPS_API = "AIzaSyAeSWmYilRQSpfgQc_aZgCioDWdEIy4HdY";
  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__GoogleMap(id, props)}`}</style>
      <div className="container">
        <iframe
          src={`https://www.google.com/maps/embed/v1/${mapMode}?key=${
            apiKey ? apiKey : GRIGORA_MAPS_API
          }&&${
            mapMode === "place"
              ? "q=" + location
              : "center=" + latitude + "," + longitude
          }&zoom=${zoom}&maptype=${mapType}&language=${language}`}
          frameBorder={"0"}
          referrerPolicy={"no-referrer-when-downgrade"}
          allowFullScreen
        ></iframe>
      </div>
      <EmbedOverlay id={id} selectNode={selectNode} selected={selected} />
    </div>
  );
};

// To Avoid Mangling in Production
GoogleMap.displayName = "GoogleMap";

GoogleMap.craft = {
  name: "Google Map",
  props: {},
  related: {
    settings: GoogleMapSettings,
    CMSsettings: CMSGoogleMapSettings,
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    icon: icon,
    CMSIcon: CMSIcon,
    keywords: ["Google", "Map", "Google Map", "Navigation"],
  },
  custom: {
    name: "Google Map",
    slug: "grigora/google-map",
  },
};
